import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add\"><path d=\"M469.333 469.333h-384a42.667 42.667 0 1 0 0 85.334h384v384a42.667 42.667 0 1 0 85.334 0v-384h384a42.667 42.667 0 1 0 0-85.334h-384v-384a42.667 42.667 0 1 0-85.334 0v384z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol